import { KeyboardArrowDown, RemoveCircle } from '@mui/icons-material';
import { ListItemIcon, ListItemText, Menu } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BulkActionButton, BulkActionMenuItem } from '~/components/bulk-actions';
import { useBulkActionIds } from '~/hooks/unique-id';

export type BulkActionsMenuProps = {
  onRemoveContent: () => void;
};

export const BulkActionsMenu = ({ onRemoveContent }: BulkActionsMenuProps) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLButtonElement>(null);

  const [open, setOpen] = useState(false);
  const { buttonId, menuId } = useBulkActionIds();

  return (
    <>
      <BulkActionButton
        ref={ref}
        disableRipple
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={() => setOpen(true)}
      >
        {t('common.buttons.bulk_actions')}
        <KeyboardArrowDown />
      </BulkActionButton>
      <Menu id={menuId} anchorEl={ref.current} open={open} onClose={() => setOpen(false)}>
        <BulkActionMenuItem
          onClick={() => {
            void onRemoveContent();
            setOpen(false);
          }}
        >
          <ListItemIcon>
            <RemoveCircle color="error" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ color: 'error' }}>
            {t('common.dialogs.remove')}
          </ListItemText>
        </BulkActionMenuItem>
      </Menu>
    </>
  );
};
